import React from 'react';
import Search from './components/Search';
import CategorySelect from './components/CategorySelect';
import DeveloperSelect from './components/DeveloperSelect';
import ResetBtn from './components/ResetBtn';
import UnassignedCheckbox from './components/UnassignedCheckbox';
import SortBy from './components/SortBy/SortBy';
import AssignBtn from './components/AssignBtn';
import style from './GameControlPanel.module.scss';

const GameControlPanel: React.FC = () => {
	return (
		<div data-test="GameControlPanel">
			<Search />
			<div className={style.firstControlUnit}>
				<CategorySelect />
				<DeveloperSelect />
				<ResetBtn />
			</div>
			<div className={style.secondControlUnit}>
				<UnassignedCheckbox />
				<SortBy />
				<AssignBtn />
			</div>
		</div>
	);
};

export default GameControlPanel;
